import { TextField } from "@material-ui/core";
import Autocomplete, {
    AutocompleteRenderInputParams,
} from "@material-ui/lab/Autocomplete";
import { ChampionshipDriver, Protest } from "api";
import { useFormikContext } from "formik";
import React from "react";
import { useFieldValueAndValidation } from "ui/componentes";

const getSelectedDriverOption = (
    option: ChampionshipDriver,
    driver: ChampionshipDriver
) => {
    return option.usedNumber === driver.usedNumber;
};

const onChangeDriver = (setFieldValue) => (event, driver) => {
    setFieldValue("protestedDriverId", driver ? driver.id : "");
};

const getDriverOptionLabel = (driver: ChampionshipDriver) =>
    `#${driver.usedNumber} - ${driver.displayName} (${driver.iracingId})`;

const renderDriverInput = (error, showError, value) => (
    params: AutocompleteRenderInputParams
) => {
    if (!value) {
        params.inputProps["value"] = "";
    }
    return (
        <TextField
            required
            {...params}
            label="Piloto protestado"
            error={showError}
            helperText={showError ? error : ""}
        />
    );
};

interface DriverSelectionProps {
    drivers: ChampionshipDriver[];
}

const ProtestedDriverSelection: React.FC<DriverSelectionProps> = ({
    drivers = [],
}) => {
    const {
        setFieldTouched,
        setFieldValue,
        values,
    } = useFormikContext<Protest>();

    const { error, hasTouched } = useFieldValueAndValidation(
        "protestedDriverId"
    );
    const showError = !!error && hasTouched;

    return (
        <Autocomplete
            style={{
                width: "100%",
            }}
            clearOnEscape={true}
            clearOnBlur={true}
            clearText="Limpar"
            onBlur={() => setFieldTouched("protestedDriverId", true)}
            getOptionSelected={getSelectedDriverOption}
            onChange={onChangeDriver(setFieldValue)}
            getOptionLabel={getDriverOptionLabel}
            options={drivers}
            renderInput={renderDriverInput(
                error,
                showError,
                values.protestedDriverId
            )}
        />
    );
};

export { ProtestedDriverSelection };
